import { Component, Prop, Inject, Vue, Emit, Watch } from 'vue-property-decorator';
import { PersonaFisica as PersonaFisicaBuscador } from '@conacyt/buscador-cvu';
import { HistoricoPagos, HistoricoPersonasApi } from '@conacyt/historicopersonasms-client';
import { PerfilApi } from '@conacyt/perfil-usuario-client';

import { StatusCodes } from 'http-status-codes';

import DatosGeneralesComponent from '@/components/expediente-persona/datos-generales/datos-generales.vue';
import VigenciasSniComponent from '@/components/expediente-persona/vigencias-sni/vigencias-sni.vue';
import AcreditacionesComponent from '@/components/expediente-persona/acreditaciones/acreditaciones.vue';
import ParticipacionesComoEvaluadorComponent from '@/components/expediente-persona/participaciones-como-evaluador/participaciones-como-evaluador.vue';
import AyudantiasComponent from '@/components/expediente-persona/ayudantias/ayudantias.vue';
import MisAyudantesComponent from '@/components/expediente-persona/mis-ayudantes/mis-ayudantes.vue';
import CuentasBancariasComponent from '@/components/expediente-persona/cuentas-bancarias/cuentas-bancarias.vue';
import ExcepcionesComponent from '@/components/expediente-persona/excepciones/excepciones.vue';
import AdeudosComponent from '@/components/expediente-persona/adeudos/adeudos.vue';
import AccountService from '@/account/account.service';
import { Authority } from '@/shared/security/authority';
import Utilidades from '@/shared/config/utilidades';
import PdfHistoricoPersonaService from '@/components/expediente-persona/pdf/PdfHistoricoPersona.service';
import VisualizadorPdfComponent from '../visualizador-pdf/visualizador-pdf.vue';
import AlertService from '@/shared/alert/alert.service';

interface HeadTables {
  key: string;
  label: string;
  class: string;
  sortable?: boolean;
  formatter?: any;
}

@Component({
  components: {
    'datos-generales': DatosGeneralesComponent,
    'vigencias-sni': VigenciasSniComponent,
    agreditaciones: AcreditacionesComponent,
    'participaciones-como-evaluador': ParticipacionesComoEvaluadorComponent,
    ayudantias: AyudantiasComponent,
    'cuentas-bancarias': CuentasBancariasComponent,
    'mis-ayudantes': MisAyudantesComponent,
    excepciones: ExcepcionesComponent,
    adeudos: AdeudosComponent,
    'visualizador-pdf': VisualizadorPdfComponent,
  },
  computed: {
    loginCvu: {
      get() {
        return this.$store.getters.userInfo?.cvu;
      },
    },
  },
})
export default class ExpedientePersonaComponent extends Vue {
  @Inject('historicoPersonasApi') private readonly historicoPersonasApi: () => HistoricoPersonasApi;
  @Inject('perfilApi') private readonly perfilApi!: () => PerfilApi;
  @Inject('accountService') private readonly accountService: () => AccountService;
  @Inject('pdfHistoricoPersonaService') private readonly pdfHistoricoPersonaService: () => PdfHistoricoPersonaService;
  @Inject('alertService') private readonly alertService: () => AlertService;

  public readonly loginCvu!: string;

  public personaCvu: PersonaFisicaBuscador = null;

  @Prop({ default: false })
  public readOnly: boolean;

  public pdfReady = false;
  public contenidoBase64 = '';
  public showPdf = false;

  /**
   * Indica si el usuario actual tiene permisos buscar otro cvu que no sea el suyo
   */
  public autorizado = true;

  @Prop({ default: null })
  public cvu: string;

  @Prop({ default: true })
  public visible: boolean;

  @Prop({ default: () => [] })
  public exclude: Array<string>;

  ayudantiasKey = 0;

  public utilidades = new Utilidades();
  public historicoPagos: Array<HistoricoPagos> = [];
  public currentPage = 1;
  public perPage = 12;
  public totalRows = 0;
  private datosCompletosExcel = [];
  private paginaSiguienteExcel = true;
  public btnExcelShow = true;
  public botonExcelDisabled = false;
  public botonPdfDisabled = false;

  created() {
    this.accountService()
      .hasAnyAuthorityAndCheckAuth([Authority.OPERADOR, Authority.INTERNAL_USER])
      .then(autorizado => {
        this.autorizado = autorizado;
      });
    if (this.cvu) {
      this.search = this.cvu;
      this.buscarPorCvu(this.search);
    }
  }

  @Watch('autorizado')
  private consultarExpedientePropio() {
    if (!this.autorizado) {
      this.search = this.loginCvu;
      this.buscarPorCvu(this.search);
    }
  }

  showSection(section: string): boolean {
    if (this.exclude?.length > 0) {
      return !this.exclude.includes(section);
    }
    return true;
  }

  expediente = null;
  search = null;

  isSearching = false;
  mensaje = 'Ingrese el CVU o uno de los datos del investigador(nombre, primer apellido o segundo apellido) y presione el botón Buscar.';
  variant = 'light';
  vigenciasVisible = true;
  acreditacionesVisible = true;
  participacionesVisible = true;
  ayudantiasVisible = true;
  participacionesEvaluadorVisible = true;
  cuentasBancariasVisible = true;
  hasError = false;

  public mensajeExpedientes = '';
  public nombre = '';
  public primerApellido = '';
  public segundoApellido = '';
  public expedientesEncontrados = [];
  public habilitarCvu = false;
  public habilitarNombreApellido = false;

  public handleSearch() {
    this.isSearching = true;
    this.expediente = null;
    this.historicoPagos = [];
    this.expedientesEncontrados = [];
    this.mensajeExpedientes = '';
    if (this.search) {
      this.buscarPorCvu(this.search);
    } else if (this.nombre || this.primerApellido || this.segundoApellido) {
      this.buscarPorNombreApellidos(this.nombre, this.primerApellido, this.segundoApellido);
    } else {
      this.mensaje = 'Ingresa al menos un criterio de búsqueda';
      this.variant = 'warning';
      this.isSearching = false;
    }
  }

  public expedientes: Array<HeadTables> = [
    { key: 'datosGenerales.persona.cvu', label: this.$t('apeironGwApp.insaculacion.cvu').toString(), class: 'text-center', sortable: true },
    {
      key: 'datosGenerales.persona.nombre',
      label: this.$t('bandeja.nombre').toString(),
      class: 'text-center',
      sortable: true,
    },
    {
      key: 'datosGenerales.persona.apellidoPaterno',
      label: this.$t('bandeja.primerApellido').toString(),
      class: 'text-center',
      sortable: true,
    },
    {
      key: 'datosGenerales.persona.apellidoMaterno',
      label: this.$t('bandeja.segundoApellido').toString(),
      class: 'text-center',
      sortable: true,
    },
    { key: 'accion', label: this.$t('bandeja.acciones').toString(), class: 'text-center' },
  ];

  /**
   * Busca expediente(s) por nombre o apellidos
   */
  public buscarPorNombreApellidos(nombre, primerApellido, segundoApellido) {
    this.isSearching = true;
    this.expediente = null;
    this.historicoPagos = [];
    this.expedientesEncontrados = [];

    this.currentPage = 1;

    this.historicoPersonasApi()
      .getExpedienteNombreApellidos(nombre, primerApellido, segundoApellido)
      .then(result => {
        if (result) {
          this.isSearching = false;
          this.expedientesEncontrados = result.data;
          this.mensajeExpedientes =
            'Seleccione algún expediente para visualizar su información y de clic en el botón para ocultar o mostrar los expedientes encontrados.';
          this.variant = 'warning';
          this.search = null;
          this.nombre = '';
          this.primerApellido = '';
          this.segundoApellido = '';
          this.hasError = false;
          this.habilitarNombreApellido = false;
          this.habilitarCvu = false;
        }
      })
      .catch(error => {
        this.search = null;
        this.isSearching = false;
        this.expediente = null;
        this.habilitarNombreApellido = false;
        this.habilitarCvu = false;

        if (error.response.data.status === StatusCodes.NOT_FOUND) {
          this.mensaje = 'No encontramos resultados para los datos ingresados';
          this.variant = 'warning';
          this.hasError = false;
          this.search = null;
          this.nombre = '';
          this.primerApellido = '';
          this.segundoApellido = '';
        } else {
          this.mensaje = 'Tuvimos problemas con la carga, por favor intenta nuevamente';
          this.variant = 'danger';
          this.hasError = true;
        }
      });
  }

  /**
   * Seleccion algun expediente dentro del array de expedientesEncontrados
   * @param item
   */
  public seleccionarExpediente(item) {
    this.expediente = item;

    this.retriveAyudantesByCvu(item.datosGenerales.persona.cvu);
    this.resolveInvestigadorInfo(item.ayudantias);
    this.personaUpdated(item);
    this.buscarHistoricoPagos(item.datosGenerales.persona.cvu);
  }

  /**
   * Busca por cvu del investigador
   * @param cvu
   */
  public buscarPorCvu(cvu) {
    this.search = cvu;
    this.isSearching = true;
    this.expediente = null;
    this.historicoPagos = [];
    this.currentPage = 1;
    this.historicoPersonasApi()
      .getExpediente(cvu)
      .then(result => {
        if (result) {
          this.isSearching = false;
          this.expediente = result.data;
          this.search = null;
          this.hasError = false;
          this.habilitarNombreApellido = false;
          this.habilitarCvu = false;

          this.retriveAyudantesByCvu(this.expediente.datosGenerales.persona.cvu);
          this.resolveInvestigadorInfo(this.expediente.ayudantias);
          this.personaUpdated(this.expediente);
          this.buscarHistoricoPagos(this.expediente.datosGenerales.persona.cvu);
        }
      })
      .catch(error => {
        this.search = null;
        this.isSearching = false;
        this.habilitarNombreApellido = false;
        this.habilitarCvu = false;

        this.expediente = null;
        if (error.response.data.status === StatusCodes.NOT_FOUND) {
          this.mensaje = 'No encontramos resultados para el cvu ingresado';
          this.variant = 'warning';
          this.hasError = false;
          this.search = null;
          this.nombre = '';
          this.primerApellido = '';
          this.segundoApellido = '';
        } else {
          this.mensaje = 'Tuvimos problemas con la carga, por favor intenta nuevamente';
          this.variant = 'danger';
          this.hasError = true;
        }
      });
  }

  @Watch('nombre')
  @Watch('primerApellido')
  @Watch('segundoApellido')
  @Watch('search')
  /**
   * Indica que campos deben deshabilitarse
   */
  public deshabilitarCampos() {
    if (this.nombre || this.primerApellido || this.segundoApellido) {
      this.habilitarCvu = true;
    } else {
      this.habilitarCvu = false;
    }

    if (this.search) {
      this.habilitarNombreApellido = true;
    } else {
      this.habilitarNombreApellido = false;
    }
  }

  public resolveInvestigadorInfo(misAyudantias) {
    console.log(misAyudantias);
    if (misAyudantias?.length > 0) {
      const cvusToFind = misAyudantias.map(ayudante => ayudante.cvuInvestigador);
      this.perfilApi()
        .getBulkPerfiles(cvusToFind)
        .then(result => {
          const investigadores = result.data;
          for (const ayudantia of this.expediente.ayudantias) {
            const investigadorFinded = investigadores.find(investigador => investigador.cvu == ayudantia.cvuInvestigador);
            ayudantia.nombreCompletoInvestigador = investigadorFinded.nombreCompleto;
          }
          this.ayudantiasKey += 1;
        })
        .catch(error => {});
    }
  }

  public misAyudantes = null;
  public retriveAyudantesByCvu(cvu) {
    this.misAyudantes = null;
    this.historicoPersonasApi()
      .getAllAyudantesByCvuInvestigador(cvu)
      .then(result => {
        if (result) {
          if (result?.data?.length > 0) {
            this.misAyudantes = result.data;
          }
        }
      })
      .catch(error => {});
  }

  @Emit('persona-updated')
  public personaUpdated(expediente) {
    return expediente;
  }

  public resolveNombreCompletoPersona() {
    if (this.expediente?.datosGenerales?.persona) {
      return (
        this.expediente.datosGenerales.persona.nombre +
        ' ' +
        this.expediente.datosGenerales.persona.apellidoPaterno +
        ' ' +
        this.expediente.datosGenerales.persona.apellidoMaterno
      );
    }
    return '';
  }

  /**
   * Obtiene el histórico de pagos paginado para mostrarlo en la tabla,
   * ya sea como investigador o como ayudante.
   */
  private buscarHistoricoPagos(cvu) {
    this.historicoPagos = [];
    this.historicoPersonasApi()
      .getHistoricoPagos(cvu, undefined, undefined, undefined, undefined, this.currentPage, this.perPage)
      .then(result => {
        let isInvestigador = false;

        if (result?.data?.length > 0) {
          this.resolvePagination(result.headers);
          for (const historicoPago of result.data) {
            let datosHistoricos;
            if (
              this.expediente.datosGenerales.persona.cvu == historicoPago.cvuInvestigador &&
              ['', '0'].includes(historicoPago.cvuAyudante) &&
              historicoPago.nivel?.trim().toUpperCase() !== 'P'
            ) {
              datosHistoricos = this.utilidades.construirHistoricoPagos(historicoPago);
              this.historicoPagos.push(datosHistoricos);
              isInvestigador = true;
            }
          }
        }

        if (isInvestigador) {
          return;
        } else {
          return this.historicoPersonasApi().getHistoricoPagos(
            undefined,
            this.expediente.datosGenerales.persona.cvu,
            undefined,
            undefined,
            undefined,
            this.currentPage,
            this.perPage
          );
        }
      })
      .then(result => {
        if (result?.data?.length > 0) {
          for (const historicoPago of result.data) {
            let datosHistoricos;
            if (this.expediente.datosGenerales.persona.cvu == historicoPago.cvuAyudante) {
              datosHistoricos = this.utilidades.construirHistoricoPagos(historicoPago);
              this.resolvePagination(result.headers);
              this.historicoPagos.push(datosHistoricos);
            }
          }
        }
      })
      .catch(error => {});
  }

  public fields = [
    { key: 'anio', label: 'Año', sortable: true },
    { key: 'nivel', label: this.$t('apeironGwApp.historicoPagos.nivel'), sortable: true },
    { key: 'ubicacion', label: this.$t('apeironGwApp.historicoPagos.ubicacion'), sortable: true },
    { key: 'sucursal', label: this.$t('apeironGwApp.historicoPagos.sucursal'), class: 'text-right', sortable: true },
    { key: 'cuentaCLABE', label: this.$t('apeironGwApp.historicoPagos.cuentaCLABE'), sortable: true },
    { key: 'mes', label: this.$t('apeironGwApp.historicoPagos.mes'), class: 'text-center', sortable: true },
    { key: 'monto', label: this.$t('apeironGwApp.historicoPagos.monto'), class: 'text-right', sortable: true },
    { key: 'montoPagar', label: this.$t('apeironGwApp.historicoPagos.montoPagar'), class: 'text-right', sortable: true },
    { key: 'montoPagado', label: this.$t('apeironGwApp.historicoPagos.montoPagado'), class: 'text-right', sortable: true },
    { key: 'montoDeducciones', label: this.$t('apeironGwApp.historicoPagos.montoDeducciones'), class: 'text-right', sortable: true },
    { key: 'estatusPago', label: this.$t('apeironGwApp.historicoPagos.estatusPago'), sortable: true },
  ];

  public handlePageChange(pageNumber: number) {
    this.historicoPagos = [];
    this.currentPage = pageNumber;
    this.buscarHistoricoPagos(this.expediente.datosGenerales.persona.cvu);
  }
  private resolvePagination(headers) {
    this.totalRows = headers['x-total'];
    this.currentPage = headers['x-page'];
  }

  /**
   * Genera el excel del Ayudante o del Investigador
   *
   * @memberof ExpedientePersonaComponent
   */
  public descargarReporteExcel() {
    this.botonExcelDisabled = true;
    this.obtenerDatosHistoricoPagos().then(() => {
      if (this.datosCompletosExcel.length > 0) {
        const columnasAFormatear = ['monto', 'montoPagar', 'montoPagado'];
        this.utilidades.exportarExcel(
          this.datosCompletosExcel,
          this.$t('apeironGwApp.historicoPagos.title').toString(),
          columnasAFormatear
        );
      }
      this.reiniciarDatos();
      this.botonExcelDisabled = false;
    });
  }

  /**
   * Obtiene todo el histórico de pagos del expediente (investigador o ayudante)
   * recorriendo todas las páginas del API.
   * Los resultados se transforman y se almacenan en `datosCompletosExcel`
   * para posteriormente ser utilizados en la generación de reportes
   * como Excel o PDF.
   */
  private obtenerDatosHistoricoPagos() {
    const cvuActual = this.expediente?.datosGenerales?.persona?.cvu;

    this.datosCompletosExcel = [];
    this.paginaSiguienteExcel = false;

    return new Promise<void>((resolve, reject) => {
      if (!cvuActual) {
        reject(new Error('No se encontró el CVU del expediente.'));
        return;
      }

      const obtenerPagina = (page: number) => {
        return this.historicoPersonasApi()
          .getHistoricoPagos(cvuActual, undefined, undefined, undefined, undefined, page, this.perPage)
          .then(result => {
            if (result?.data?.length > 0) {
              const filtradosInvestigador = result.data.filter(
                r => r.cvuInvestigador == cvuActual && ['', '0'].includes(r.cvuAyudante) && r.nivel?.trim().toUpperCase() !== 'P'
              );

              const datos = filtradosInvestigador.map(r => this.utilidades.construirHistoricoPagosExcelBuscadorExpediente(r));

              this.datosCompletosExcel = this.datosCompletosExcel.concat(datos);
              this.paginaSiguienteExcel = Number(result.headers['x-total-pages']) > page;

              if (this.paginaSiguienteExcel) {
                return obtenerPagina(page + 1);
              }

              resolve();
              return null;
            }

            return this.historicoPersonasApi().getHistoricoPagos(undefined, cvuActual, undefined, undefined, undefined, page, this.perPage);
          })
          .then(result => {
            if (!result) {
              return;
            }

            if (result?.data?.length > 0) {
              const filtradosAyudante = result.data.filter(r => r.cvuAyudante == cvuActual);

              const datos = filtradosAyudante.map(r => this.utilidades.construirHistoricoPagosExcelBuscadorExpediente(r));

              this.datosCompletosExcel = this.datosCompletosExcel.concat(datos);
              this.paginaSiguienteExcel = Number(result.headers['x-total-pages']) > page;

              if (this.paginaSiguienteExcel) {
                return obtenerPagina(page + 1);
              }
            }

            resolve();
          })
          .catch(error => {
            reject(error);
          });
      };

      obtenerPagina(1);
    });
  }

  private reiniciarDatos() {
    this.datosCompletosExcel = [];
    this.paginaSiguienteExcel = false;
  }

  /**
   * Genera el excel de vigencias
   */
  public descargarReporteExcelVigencias() {
    const datos = this.expediente.vigenciasSni.map(r => this.utilidades.construirHistoricoVigencias(r));
    if (datos) {
      this.utilidades.exportarExcel(datos, this.$t('apeironGwApp.persona.expediente.vigencias.sni.title').toString());
    }
    this.reiniciarDatos();
  }

  /**
   * Genera el excel de cuentas bancarias
   */
  public descargarReporteExcelCuentasBancarias() {
    const datos = this.expediente.cuentasBancarias.map(r => this.utilidades.construirHistoricoCuentasBancarias(r));
    if (datos) {
      this.utilidades.exportarExcel(datos, this.$t('apeironGwApp.persona.expediente.cuentas.title').toString());
    }
    this.reiniciarDatos();
  }

  /**
   * Genera el excel de  acreditaciones
   */
  public descargarReporteExcelAcreditaciones() {
    const datos = this.expediente.acreditaciones.map(r => this.utilidades.construirHistoricoAcreditaciones(r));
    if (datos) {
      this.utilidades.exportarExcel(datos, this.$t('apeironGwApp.persona.expediente.acreditaciones.title').toString());
    }
    this.reiniciarDatos();
  }

  /**
   * Genera el excel de Excepciones
   */
  public descargarReporteExcelExcepciones() {
    const datos = this.expediente.excepcionesInvestigador.map(r => this.utilidades.construirHistoricoExcepciones(r));
    if (datos) {
      this.utilidades.exportarExcel(datos, this.$t('apeironGwApp.persona.expediente.excepciones.title').toString());
    }
    this.reiniciarDatos();
  }
  /**
   * Genera el excel de Participaciones Como Evaluador
   */
  public descargarReporteExcelParticipacionesComoEvaluador() {
    const datos = this.expediente.participacionesEvaluador.map(r => this.utilidades.construirHistoricoParticipacionesComoEvaluado(r));
    if (datos) {
      this.utilidades.exportarExcel(datos, this.$t('apeironGwApp.persona.expediente.participaciones.excel').toString());
    }
    this.reiniciarDatos();
  }
  /**
   * Genera el excel de Ayudantias
   */
  public descargarReporteExcelAyudantias() {
    const datos = this.expediente.ayudantias.map(r => this.utilidades.construirHistoricoAyudantias(r));
    if (datos) {
      this.utilidades.exportarExcel(datos, this.$t('apeironGwApp.persona.expediente.ayudantias.title').toString());
    }
    this.reiniciarDatos();
  }
  /**
   * Genera el excel de MisAyudantes
   */
  public descargarReporteExcelMisAyudantes() {
    const datos = this.misAyudantes.map(r => this.utilidades.construirHistoricoMisAyudantes(r));
    if (datos) {
      this.utilidades.exportarExcel(datos, this.$t('apeironGwApp.persona.expediente.misAyudantes.subtitle').toString());
    }
    this.reiniciarDatos();
  }

  /**
   * Genera el documento pdf y lo muestra en el visualizador-pdf de vigencia
   */
  public async generarVisualizarPdfVigencias() {
    try {
      this.showPdf = true; //Activa overlay
      this.pdfReady = false;
      this.botonPdfDisabled = true;
      const responseDocumento = await this.pdfHistoricoPersonaService().exportarPdfVigencias(this.expediente.datosGenerales.persona.cvu);
      this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
      this.showPdf = false;
      this.pdfReady = true;
      this.botonPdfDisabled = false;
    } catch (error) {
      this.showPdf = false;
      this.botonPdfDisabled = false;
      this.alertService().showHttpError(this, error.response);
    }
  }

  /**
   * Genera el PDF del histórico de pagos y lo muestra en el visualizador.
   */
  public async generarVisualizarPdfHistoricoPagos(listaPagos: Array<HistoricoPagos>) {
    try {
      this.showPdfHistoricoPagos = true;
      this.pdfReady = false;
      this.botonPdfHistoricoPagosDisabled = true;
      const responseDocumento = await this.pdfHistoricoPersonaService().exportarPdfHistoricoPagos(
        this.expediente.datosGenerales.persona.cvu,
        listaPagos
      );
      this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
      this.showPdfHistoricoPagos = false;
      this.pdfReady = true;
      this.botonPdfHistoricoPagosDisabled = false;
    } catch (error) {
      this.showPdfHistoricoPagos = false;
      this.botonPdfHistoricoPagosDisabled = false;
      this.alertService().showHttpError(this, error.response);
    }
  }

  /**
   * Genera el PDF completo del histórico de pagos sin aplicar filtros
   * de año o mes. Se utiliza cuando el usuario selecciona la opción
   * "Descargar PDF completo" en el modal.
   */
  public async descargarPdfCompleto() {
    if (!this.listaPagosParaPdf || this.listaPagosParaPdf.length === 0) {
      this.alertService().showError(this, 'No hay pagos para generar el PDF completo.');
      return;
    }

    this.modalPdfHistoricoPagosVisible = false;

    await this.generarVisualizarPdfHistoricoPagos(this.listaPagosParaPdf);
    this.reiniciarDatos();
  }

  public modalPdfHistoricoPagosVisible = false;
  public showPdfHistoricoPagos = false;
  public botonPdfHistoricoPagosDisabled = false;

  public anioSeleccionado = '';
  public mesesSeleccionados: string[] = [];

  public listaPagosParaPdf: Array<HistoricoPagos> = [];

  /**
   * Obtiene los años disponibles a partir de la lista de pagos
   * para mostrarlos en el selector del modal.
   */
  public get aniosDisponibles(): string[] {
    const anios = this.listaPagosParaPdf.map(p => String((p as any).anio ?? '')).filter(Boolean);

    return Array.from(new Set(anios)).sort();
  }

  /**
   * Obtiene los meses disponibles del año seleccionado
   * para mostrarlos como opciones en los checkboxes del modal.
   */
  public get mesesDisponibles(): Array<{ value: string; text: string }> {
    const nombres: Record<string, string> = {
      '1': 'Enero',
      '2': 'Febrero',
      '3': 'Marzo',
      '4': 'Abril',
      '5': 'Mayo',
      '6': 'Junio',
      '7': 'Julio',
      '8': 'Agosto',
      '9': 'Septiembre',
      '10': 'Octubre',
      '11': 'Noviembre',
      '12': 'Diciembre',
    };

    if (!this.anioSeleccionado) return [];

    const meses = Array.from(
      new Set(
        this.listaPagosParaPdf
          .filter(p => String((p as any).anio) === String(this.anioSeleccionado))
          .map(p => String((p as any).mes ?? ''))
          .filter(Boolean)
      )
    ).sort((a, b) => Number(a) - Number(b));

    return meses.map(m => ({ value: m, text: nombres[m] ?? m }));
  }

  /**
   * Abre el modal para seleccionar el periodo del PDF
   * y prepara la lista de pagos disponibles para filtrar.
   */
  public abrirModalPdf(lista: Array<HistoricoPagos>) {
    this.listaPagosParaPdf = lista;
    this.anioSeleccionado = '';
    this.mesesSeleccionados = [];
    this.modalPdfHistoricoPagosVisible = true;
  }

  /**
   * Limpia la selección de meses cuando el usuario cambia el año.
   */
  public onChangeAnio() {
    this.mesesSeleccionados = [];
  }

  /**
   * Selecciona todos los meses disponibles del año seleccionado.
   */
  public seleccionarTodosMeses() {
    this.mesesSeleccionados = this.mesesDisponibles.map(o => String(o.value));
  }

  /**
   * Valida la selección de año y meses, filtra los pagos correspondientes
   * y genera el PDF del histórico de pagos para el periodo seleccionado.
   */
  public async confirmarPdfPorPeriodo() {
    if (!this.anioSeleccionado) {
      this.alertService().showError(this, 'Selecciona un año.');
      return;
    }

    if (this.mesesSeleccionados.length === 0) {
      this.alertService().showError(this, 'Selecciona al menos un mes.');
      return;
    }

    const setMeses = new Set(this.mesesSeleccionados.map(String));

    const listaFiltrada = this.listaPagosParaPdf.filter(
      p => String((p as any).anio) === String(this.anioSeleccionado) && setMeses.has(String((p as any).mes))
    );

    if (listaFiltrada.length === 0) {
      this.alertService().showError(this, 'No hay pagos para la selección.');
      return;
    }

    this.modalPdfHistoricoPagosVisible = false;

    await this.generarVisualizarPdfHistoricoPagos(listaFiltrada);
    this.reiniciarDatos();
  }

  /**
   * Obtiene el histórico completo de pagos y abre el modal
   * para seleccionar el periodo y generar el PDF.
   */
  public abrirModalPdfHistoricoPagos() {
    this.showPdfHistoricoPagos = true;
    this.botonPdfHistoricoPagosDisabled = true;

    this.reiniciarDatos();
    this.listaPagosParaPdf = [];
    this.anioSeleccionado = '';
    this.mesesSeleccionados = [];

    this.obtenerDatosHistoricoPagos()
      .then(() => {
        if (this.datosCompletosExcel.length > 0) {
          this.abrirModalPdf([...this.datosCompletosExcel]);
        } else {
          this.alertService().showError(this, 'No hay datos para generar PDF.');
          this.reiniciarDatos();
        }
      })
      .finally(() => {
        this.showPdfHistoricoPagos = false;
        this.botonPdfHistoricoPagosDisabled = false;
      });
  }

  /**
   * Genera el excel de Adeudos
   */
  public descargarReporteExcelAdeudos() {
    const datos = this.expediente.excepcionesInvestigador.map(r => this.utilidades.construirHistoricoAdeudos(r));
    if (datos) {
      this.utilidades.exportarExcel(datos, this.$t('apeironGwApp.persona.expediente.excepciones.title').toString());
    }
    this.reiniciarDatos();
  }

  /**
   * Genera el documento PDF y lo muestra en el visualizador PDF de acreditaciones.
   */
  public async generarVisualizarPdfAcreditaciones() {
    try {
      this.showPdf = true; //Activa overlay
      this.pdfReady = false;
      this.botonPdfDisabled = true;
      const responseDocumento = await this.pdfHistoricoPersonaService().exportarPdfAcreditaciones(
        this.expediente.datosGenerales.persona.cvu
      );
      this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
      this.showPdf = false;
      this.pdfReady = true;
      this.botonPdfDisabled = false;
    } catch (error) {
      this.showPdf = false;
      this.botonPdfDisabled = false;
      this.alertService().showHttpError(this, error.response);
    }
  }

  public async generarVisualizarPdfCuentasBancarias() {
    try {
      this.showPdf = true;
      this.pdfReady = false;
      this.botonPdfDisabled = true;
      const responseDocumento = await this.pdfHistoricoPersonaService().exportarPdfCuentasBancarias(
        this.expediente.datosGenerales.persona.cvu
      );
      this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
      this.showPdf = false;
      this.pdfReady = true;
      this.botonPdfDisabled = false;
    } catch (error) {
      this.showPdf = false;
      this.botonPdfDisabled = false;
      this.alertService().showHttpError(this, error.response);
    }
  }

  get noTieneAdeudo() {
    return this.expediente.adeudos?.every(adeudo => adeudo.monto === 0) ?? false;
  }
}
